import React, { createContext, useState, useContext, useCallback } from 'react';
import axios from 'axios';

const FAQContext = createContext();

export const FAQProvider = ({ children }) => {
  const [faqData, setFaqData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  const fetchFAQs = useCallback(async () => {
    if (isLoaded) return; // Don't fetch if already loaded

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getFAQs`);
      console.log(response);
      
      const faqs = (Array.isArray(response.data) ? response.data : 
                  response.data.faqs ? response.data.faqs :
                  response.data.data ? response.data.data : [])
                  .map((faq, index) => ({
                    ...faq,
                    id: faq.id || faq._id || index + 1
                  }));
      setFaqData(faqs);
      setIsLoaded(true);
    } catch (error) {
      console.error('Error fetching FAQs:', error);
      // Fallback data
      setFaqData([
        {
          id: 1,
          question: "What equipment do I need to bring?",
          answer: "As a DJ at the polls, you'll need to bring your own headphones and laptop. If you're assigned to an outdoor location, we'll provide a generator for power."
        },
        {
          id: 2,
          question: "How long are the shifts?",
          answer: "Shifts typically run during polling hours on Election Day (7 AM - 8 PM). You can choose between full-day or half-day shifts based on your availability."
        },
        {
          id: 3,
          question: "What music can I play?",
          answer: "We encourage a diverse mix of family-friendly music that creates a positive atmosphere. You'll receive detailed guidelines about playlist recommendations before your shift."
        },
        {
          id: 4,
          question: "Will I receive payment for my services?",
          answer: "Yes! DJs are compensated for their time. Payment details will be provided in your contract once you're selected for an election."
        },
        {
          id: 5,
          question: "What happens after I apply?",
          answer: "After applying, our team will review your application. If selected, you'll receive a contract to sign, followed by an invitation to our informational session and Election Day Eve call."
        }
      ]);
      setIsLoaded(true);
    }
  }, [isLoaded]);

  return (
    <FAQContext.Provider value={{ faqData, fetchFAQs, isLoaded }}>
      {children}
    </FAQContext.Provider>
  );
};

export const useFAQ = () => {
  const context = useContext(FAQContext);
  if (!context) {
    throw new Error('useFAQ must be used within a FAQProvider');
  }
  return context;
};
